import "./styles.scss";

import { Link, navigate } from "gatsby";
import React, { useEffect, useState } from "react";

import { AnimatePresence, motion } from "framer-motion";

const Input = ({ placeholder, onSubmit, onChange }) => {
  return (
    <div className="blog-main__filters__input">
      <input
        type="text"
        placeholder={placeholder}
        onChange={(e) => onChange(e?.target?.value)}
      />
      <button onClick={onSubmit}>
        <img
          src={require("assets/icons/arrow-right--new.svg").default}
          alt=""
        />
      </button>
    </div>
  );
};

const PaginationModal = ({ current_page, count }) => {
  const [page_number, setPageNumber] = useState(null);

  const items = Array.from({ length: count }, (_, index) => index + 1);

  useEffect(() => {
    document.body.classList.add("mobile-menu--open");

    return () => document.body.classList.remove("mobile-menu--open");
  }, []);

  const numberPageHandler = () => {
    let page = page_number;
    if (page === "0" || page === "1") {
      page = null;
    }

    navigate(`/blog${!!page ? `/page/${page}/` : ""}`);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="pagination-modal"
        initial={{ opacity: 1, clipPath: "circle(0% at 100% 0%)" }}
        animate={{ opacity: 1, clipPath: "circle(150% at 100% 0%)" }}
        exit={{ opacity: 0, clipPath: "circle(150% at 100% 0%)" }}
        transition={{
          opacity: {
            type: "tween",
            duration: 0.3,
          },
          clipPath: {
            type: "tween",
            ease: "easeInOut",
            duration: 0.5,
          },
        }}
      >
        <div className="pagination-modal__body">
          <AnimatePresence exitBeforeEnter initial={false}>
            <motion.div
              className="pagination-modal__body-inner"
              initial={{ opacity: 0, height: "25%" }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: "25%" }}
              transition={{
                type: "tween",
                ease: "easeInOut",
                duration: 0.4,
              }}
            >
              <AnimatePresence exitBeforeEnter>
                <motion.div
                  className="blog-main__filters__categories__actions-dropdown-inner"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ type: "tween", duration: 0.3 }}
                  // onAnimationStart={(definition) => {
                  //   if (definition.opacity === 1) handleDropdownHeight();
                  // }}
                >
                  <div className="pagination-modal-content">
                    <p className="pagination-modal-content__title">
                      Przejdź do podstrony z wpisami
                    </p>
                    <div className="pagination-modal-content__content">
                      <Input
                        onSubmit={numberPageHandler}
                        placeholder="Podaj numer strony i przejdź"
                        onChange={setPageNumber}
                      />
                      <div className="pagination-modal-content__content__grid">
                        {items?.map((item, index) => (
                          <Link
                            to={`/blog/page/${item}/`}
                            key={index}
                            className={current_page === item ? "active" : ""}
                          >
                            {item}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
              {/* {getSubmenu(submenu)} */}
            </motion.div>
          </AnimatePresence>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PaginationModal;
